import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader,
  AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export default function DeleteUserDialog({ account, onDelete, disabled = false }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button type="button" variant="outline" size="sm" disabled={disabled} className="rounded-none text-primary" title={disabled ? "Akun sendiri tidak dapat dihapus" : undefined}>
          Hapus
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="rounded-none">
        <AlertDialogHeader>
          <AlertDialogTitle>Hapus {account.role}?</AlertDialogTitle>
          <AlertDialogDescription>
            Akun {account.name} ({account.email || account.username}) akan dihapus. Semua meeting yang dibuat akun ini, termasuk file Recording dan Manual Minutes, juga akan dihapus permanen. Tindakan ini tidak dapat dibatalkan.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-none">Batal</AlertDialogCancel>
          <AlertDialogAction className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90" onClick={() => onDelete(account)}>
            Hapus akun
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
